<form [formGroup]="form">
  <h4>Duration</h4>
  <div class="row">
    <mat-form-field
      color="accent"
      class="col-4 col-lg-2"
    >
      <mat-label>Year(s)</mat-label>
      <input
        matInput
        type="number"
        min="0"
        formControlName="durationYears"
      >
    </mat-form-field>
    <mat-form-field
      color="accent"
      class="col-4 col-lg-2 pl-0"
    >
      <mat-label>Month(s)</mat-label>
      <input
        matInput
        type="number"
        min="0"
        formControlName="durationMonths"
      >
    </mat-form-field>
  </div>

  <ng-container *ngIf="!isSow; else isSowTemplate">
    <div class="row">
      <div class="col-12 col-lg-6">
        <h4>Pay rate hourly</h4>
        <div class="row">
          <div class="col-4">
            <mojo-currency-dropdown
              [parentForm]="form"
              controlName="payRateCurrency"
            >
            </mojo-currency-dropdown>
          </div>
          <mat-form-field
            color="accent"
            class="col-4 pl-0"
          >
            <mat-label>Min</mat-label>
            <input
              matInput
              id="minPayRate"
              formControlName="minPayRate"
              placeholder="Min"
              mask="coma_separator"
            >
          </mat-form-field>
          <mat-form-field
            color="accent"
            class="col-4 pl-0"
          >
            <mat-label>Max</mat-label>
            <input
              matInput
              id="maxPayRate"
              formControlName="maxPayRate"
              placeholder="Max"
              mask="coma_separator"
            >
          </mat-form-field>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <h4>Bill rate hourly</h4>
        <div class="row">
          <div class="col-4">
            <mojo-currency-dropdown
              [parentForm]="form"
              controlName="billRateCurrency"
            >
            </mojo-currency-dropdown>
          </div>
          <mat-form-field
            class="col-4 pl-0"
            color="accent"
          >
            <mat-label>Min</mat-label>
            <input
              matInput
              type="text"
              id="minBillRate"
              placeholder="Min"
              formControlName="minBillRate"
              mask="coma_separator"
            />
          </mat-form-field>
          <mat-form-field
            class="col-4 pl-0"
            color="accent"
          >
            <mat-label>Max</mat-label>
            <input
              matInput
              type="text"
              placeholder="Max"
              formControlName="maxBillRate"
              mask="coma_separator"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #isSowTemplate>
    <div class="row pay-rate-selector">
      <mat-radio-group (change)="onPayRateChange($event)">
        <mat-radio-button
          [checked]="currentTimePeriod=== timePeriods.Annually"
          [value]="timePeriods.Annually"
        >
          Annual salary
        </mat-radio-button>
        <mat-radio-button
          [checked]="currentTimePeriod === timePeriods.Hourly"
          [value]="timePeriods.Hourly"
        >
          Hourly bill rate
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <mojo-job-salary-full-time
      [isSowJobType]="true"
      [form]="form"
    ></mojo-job-salary-full-time>
  </ng-template>
</form>
